import {To} from "react-router-dom";

/**
 * How a table row answers a click.
 *
 * A row *navigates* when its config yields a link, *picks* when its config
 * takes the click, and is otherwise *inert*. A config carrying both is legal,
 * and picks: a pick is a decision taken in place, never followed by a move.
 * A row that would navigate or pick but is disabled *refuses*: it answers
 * nothing, and the cursor says so.
 */
export type RowInteraction = {type: "navigate"; link: To} | {type: "pick"} | {type: "refused"} | {type: "inert"};

export function rowInteraction({
  link,
  picks,
  disabled,
}: {
  link: To | undefined;
  picks: boolean;
  disabled: boolean;
}): RowInteraction {
  if (disabled) return picks || link != null ? {type: "refused"} : {type: "inert"};
  if (picks) return {type: "pick"};
  if (link != null) return {type: "navigate", link};
  return {type: "inert"};
}

/** The link a cell's contents sit inside, if any. */
export function cellRowLink(interaction: RowInteraction, disableRowInteraction: boolean): To | undefined {
  return interaction.type === "navigate" && !disableRowInteraction ? interaction.link : undefined;
}
